module.exports = __webpack_public_path__ + "static/1-0ac6a5a004ad6a1854a320018f22ec0a.jpg";